import {Tooltip, Tabs} from 'antd';
import React, {useState} from 'react';
import '../../../css/cardPreview.css';
import {alarm_hint_tooltip_css as alarmHintTooltipCss} from "../../../utils/PublicConstant";
import Icon from '@ant-design/icons';
import alarmImg from  "../../../imagers/icon/alarm.png";
import CardEquipmentTooltip from "../../../utils/module/CardEquipmentTooltip";
import CardHighchartsPie from "../../../utils/module/CardHighchartsPie";
import CardDigitalModule from "../../../utils/module/CardDigitalModule";

interface CardData{
    param:any,
    realData:any,
    setItems:any,
    setActiveKey:any,
    items:any,
    viewTypeList:any,
    setViewTypeList:any;
    viewOperate:any;
}
const InverterPreview: React.FC<CardData> = (cardData) => {
    const [items,setItems] = useState<any[]>([]);
    const [trackRealData,setTrackRealData] = useState<any[]>([]);
    const [trackSeries,setTrackSeries] = useState<any[]>([]);

    React.useEffect(() => {
        let newData = cardData.realData?.find((item:any) => item.id == cardData.param.id)?.data;
        if(newData != null && newData.motors.length > 0){
            let devs = new Array();
            for(let i=0;i<newData.motors.length;i++){
                const data = newData.motors[i];
                devs.push({
                    label:<span className="preview-tabs-head-label">{data.name}</span>,
                    key:""+(i+1),
                    children:<div className={"preview-tabs-content"}>
                        <table className="table table-borderless">
                            <tbody>
                                <tr>
                                    <td colSpan={2} width="50%" className="equipment-name-background">
                                        <CardEquipmentTooltip name={"设备名称"} nameLabel={data?.name}/>
                                    </td>
                                    <td colSpan={2} width="50%">
                                        <CardEquipmentTooltip name={"型号规格"} nameLabel={""}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2} width="50%">输入档位：{data?.gearMerge}</td>
                                    <td colSpan={2} width="50%">
                                        {data?.speed!=null?'电机转速':'输出频率'}：
                                        {data?.speed!=null?data?.speed:data?.freq}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2} width="50%">母线电压：{data?.voltage}</td>
                                    <td colSpan={2} width="50%">平均电流：{data?.current}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} width="50%">输出转矩：{data?.torque}</td>
                                    <td colSpan={2} width="50%">累计运行：{data?.devRunTime}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} width="50%">设备保养：{data?.usageState}</td>
                                    <td colSpan={2} width="50%">
                                        <CardDigitalModule digitalName="制动输出" digitalValue={data?.brake}></CardDigitalModule>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={4}>
                                        <div style={{display:"flex",width:'350px'}} id={"alarmDiv"}>
                                            <div style={{margin:"2px 20px 0px 0px"}}>故障提示：{data?.fault}</div>
                                            <div style={{overflow:"hidden",flex:"1"}}>
                                                <Tooltip title={""} color="#C9CACA" overlayInnerStyle={alarmHintTooltipCss} placement="bottom">
                                                    <div className="alarm-hint-tooltip-content"><span className="cancel-bold"></span></div>
                                                </Tooltip>
                                            </div>
                                            <div style={{margin:"0px 3px"}}>
                                                <Icon component={() => (<img src={alarmImg} style={{display:"none",width:"13px",height:"13px"}}/>)}/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                });
                setItems(devs);
            }
            let realData = new Array(),series = new Array();
            for(let i=0;i<newData.motors.length;i++){
                const data = newData.motors[i];
                series.push(data.name+"转速");
                series.push(data.name+"电压");
                series.push(data.name+"电流");
                realData.push(data?.speed);
                realData.push(data?.voltage);
                realData.push(data?.current);
            }
            setTrackRealData(realData);
            setTrackSeries(series);
        }
    },[cardData.realData]);
    return (
        <>
            <div className={"preview-tabs-head"} style={{height:"225px"}}>
                <Tabs defaultActiveKey="1" type="card" size={"middle"} tabBarStyle={{}} items={items}/>
            </div>
            <div className={"preview-tabs-head"} style={{marginTop:"10px"}}>
                <Tabs defaultActiveKey="1" type="card" size={"middle"} style={{}} onChange={(activeKey:string)=>{}}
                    items={[
                        {
                            key:"1",
                            label:<span className="preview-tabs-head-label">报警显示</span>,
                            children:<CardHighchartsPie param={cardData.param} seriesData={cardData.param.data?.alarmSumItems} />
                        }/*, {
                                label:<span className="preview-tabs-head-label">轨迹曲线</span>,
                                key:"2",
                                children:<CardHighchartsSpline realData={trackRealData} param={cardData.param} series={trackSeries}/>
                            }*/
                    ]}
                />
            </div>
        </>
    );
};

export default InverterPreview;